angular.module('callX').controller('CampaignsListCtrl', ['$scope', 'CampaignsService', function($scope, CampaignsService) {

    $scope.campaignsList = [];
    $scope.tableContentLoading = false;
    $scope.filterValue = "Default";
    $scope.filterStatus = ['approved', 'pending'];
    $scope.filterCampaign = ['active'];

    // $scope.matchStatus = function(status) {
    //     return function(campaign) {
    //         if ($scope.filterStatus.length < 1 && $scope.filterCampaign.length < 1)
    //         {
    //             return true;
    //         } else if ($scope.filterStatus.length < 1 && $scope.filterCampaign.length > 0) {
    //             for (var i=0; i < $scope.filterCampaign.length; i++) {
    //                 if (campaign.status == $scope.filterCampaign[i]) {
    //                     return true;
    //                 }
    //             }
    //         } else if ($scope.filterStatus.length < 1 ) {
    //             return true;
    //         } else {
    //             for (var i=0; i < $scope.filterStatus.length; i++) {
    //                 if (campaign.status == $scope.filterStatus[i])
    //                 {
    //                     if ($scope.filterCampaign.length > 0 && campaign.status != $scope.filterCampaign[0]) {
    //                         return false;
    //                     }
    //                     return true;
    //                 }
    //             }
    //         }
    //         return false;
    //     }
    // };

    $scope.matchStatus = function(status) {
        return function(campaign) {
            if ($scope.filterStatus.length < 1)
            {
                return true;
            } else {
                for (var i=0; i < $scope.filterStatus.length; i++) {
                    if (campaign.status == $scope.filterStatus[i])
                    {
                        return true;
                    }
                }
            }
            return false;
        }
    };

    var checkForNumberOfElements = function () {
        var filteredElementsCount = 0;
        if($scope.filterStatus == "" && $scope.campaignsList.length == 0){
            $scope.showNoDataDiv = true;
        }
        else if($scope.filterStatus == "" && $scope.campaignsList.length > 0){
            
            $scope.showNoDataDiv = false;
        }
        else if($scope.filterStatus != "") {
          for(var j = 0; j < $scope.campaignsList.length; j++){
            for (var i=0; i < $scope.filterStatus.length; i++) {
                if ($scope.campaignsList[j].status == $scope.filterStatus[i])
                {
                    filteredElementsCount += 1;
                }
            }
        }  
        $scope.showNoDataDiv = (filteredElementsCount==0);
        }
    };

    $scope.toggleSelectAll = function() {
        //Loop through all the entities and set their isChecked property
        for (var i = 0; i < $scope.campaignsList.length; i++) {
            $scope.campaignsList[i].isChecked = $scope.selectAllCampaigns;
        }

        //Set "checkBoxActionsContainer" buttons
        $scope.checkBoxActionsContainer = $scope.selectAllCampaigns;
    };

    $scope.uncheckAll = function() {
        $scope.selectAllCampaigns = false;
        $scope.toggleSelectAll();
    };

    // $scope.filterByStatus = function(stat) {
    //     if (stat == 'active') {
    //         $scope.filterStatus = ['approved'];
    //         $scope.filterCampaign = ['active'];
    //     } else if (stat == 'expired') { // expired, suspended
    //         $scope.filterStatus = ['expired'];
    //         $scope.filterCampaign = [stat];
    //     } else if (stat == 'suspended') { // expired, suspended
    //         $scope.filterStatus = ['suspended'];
    //         $scope.filterCampaign = [stat];
    //     } 
    //     else if (stat == 'archived') {
    //         $scope.filterStatus = ['archived'];
    //         $scope.filterCampaign = [];
    //     } else if (stat == 'default') {
    //         $scope.filterStatus = ['approved', 'pending'];
    //         $scope.filterCampaign = ['active'];
    //     } else if (stat != '') { // pending, declined
    //         $scope.filterStatus = [stat];
    //         $scope.filterCampaign = ['active'];
    //         if (stat == 'declined')
    //             $scope.filterCampaign = [];
    //     } else { // view all
    //         $scope.filterStatus = [];
    //         $scope.filterCampaign = [];
    //     }

    //     $scope.filterValue = (stat == 'pending')? 'Applied' : $scope.capitalize(stat);

    //     // uncheck all box if filter is selected
    //     checkForNumberOfElements();
    //     $scope.uncheckAll();
    // };

    $scope.filterByStatus = function(stat) {
        if (stat == "") {
            $scope.filterStatus = [];
            $scope.filterValue = "View All";
        } 
        else if (stat == "default") {
            $scope.filterStatus = ['pending', 'approved'];
            $scope.filterValue = 'Default';
            
        } 
        else if (stat == "active") {
            $scope.filterStatus = ["approved"];
            $scope.filterValue = 'Active';
        } 
        else {
            $scope.filterStatus = [stat];
            $scope.filterValue = $scope.capitalize(stat);
        }

        $scope.filterValue = (stat == 'pending')? 'Pending' : $scope.capitalize(stat);
        // if (stat != "") {
        //     $scope.filterValue = $scope.capitalize(stat);
        // }
        // uncheck all box if filter is selected
        checkForNumberOfElements();
        $scope.uncheckAll();
    };

    $scope.orderParam = 'total_earnings';
    $scope.reverse = true;
    $scope.order = function(orderParam) {
        $scope.reverse = ($scope.orderParam === orderParam) ? !$scope.reverse : false;
        $scope.orderParam = orderParam;
    };

    var fetchCampaignsList = function(){
        $scope.tableContentLoading = true;
        var callbacks = {
            success: function(data) {
//                console.log("data",data);
                $scope.campaignsList = data.data;
                for(var i = 0; i < $scope.campaignsList.length; i++){
                    $scope.campaignsList[i].calculated_epc = (($scope.campaignsList[i].total_earnings)/isNaN($scope.campaignsList[i].total_calls) ? 0 : ($scope.campaignsList[i].total_earnings)/($scope.campaignsList[i].total_calls));
                    // $scope.campaignsList[i].calculated_epc = (($scope.campaignsList[i].total_earnings)/($scope.campaignsList[i].total_calls) == NaN ? 0 : ($scope.campaignsList[i].total_earnings)/($scope.campaignsList[i].total_calls));
                    $scope.campaignsList[i].evaluated_status = ($scope.campaignsList[i].campaign.status == 'active')? (($scope.campaignsList[i].status == 'approved')?
                        'active' : (($scope.campaignsList[i].status == 'pending')? 'applied' : $scope.campaignsList[i].status)) :
                        (($scope.campaignsList[i].status == 'archived' || $scope.campaignsList[i].status == 'declined')?
                            $scope.campaignsList[i].status : $scope.campaignsList[i].campaign.status);
                    $scope.campaignsList[i].total_earnings = ($scope.campaignsList[i].total_earnings==null) ? (0) : ($scope.campaignsList[i].total_earnings);
                    $scope.campaignsList[i].total_calls = ($scope.campaignsList[i].total_calls==null) ? (0) : ($scope.campaignsList[i].total_calls);
                    if($scope.campaignsList[i].total_calls==0){
                        $scope.campaignsList[i].calculated_epc = 0;
                    }
                    else{
                        $scope.campaignsList[i].calculated_epc = $scope.campaignsList[i].total_earnings / $scope.campaignsList[i].total_calls;
                    }
                }
                $scope.tableContentLoading = false;
            },
            failure: function(data) {
                $scope.tableContentLoading = false;
            }
        };
        CampaignsService.getCampaignsList(callbacks);
    };

    fetchCampaignsList();

}]);